<template>
  <div class="header-block">
    <head-title>
      <slot />
    </head-title>
    <stages-legend
      :class="{'stages-legend_stage2': stages[1].active}"
      class="stages-legend" :stages="stages"></stages-legend>
  </div>
</template>

<script>
export default {
  props: {
    stages: {
      required: true,
      type: Array,
    },
  },
};
</script>


<style lang="scss" scoped>
.header-block {
  padding: 30px;
  border-bottom: $common-border;
}
.stages-legend {
  margin-top: 37px;
}
@media only screen and (max-width : 540px) {
  .stages-legend {
    @include incrSelectorWeight(1) {
      width: 120%;
      min-width: 540px;
    }
    &_stage2 {
      @include incrSelectorWeight(1) {
        $w: 261px;
        min-width: $w;
        width: $w;
        margin-left: -138px;
      }
    }
  }
  .header-block {
    overflow-x: hidden;
  }
}
@media only screen and (max-width : 432px) {
  .header-block {
    padding: 27px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/alertCreation/TheHeader.vue